import axios from "axios";
import { AutoComplete, AutoCompleteCompleteEvent } from "primereact/autocomplete";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Location } from "../models/Models";
// {
//     coordinates: {
//         lat: 0,
//         long: 0,
//     },
//     country: "",
//     fullName: "",
//     id: 0,
//     name: "",
//     score: 0,
//     type: "",
// }

interface SearchBarInputs {
    searchBarResult: Location;
    setSearchBarResult: Dispatch<SetStateAction<Location>>;
    locationsData: Location[];
    setLocationsData: Dispatch<SetStateAction<Location[]>>;
    autoSuggestUrl: string,
    isSearchEnabled: boolean
}

function SearchBar({ isSearchEnabled, searchBarResult, setSearchBarResult, locationsData, setLocationsData, autoSuggestUrl }: SearchBarInputs) {
    const itemTemplate = (location: Location) => {
        return (
            <div className="flex align-items-center">
                <div className="mr-2">
                    {(location.type === "city" || location.type === "multiCity" || location.type === "neighborhood" || location.type === "state") && (
                        <i className="pi pi-map-marker"></i>
                    )}
                    {location.type === "hotel" && <i className="pi pi-building"></i>}
                    {location.type === "trainStation" && <i className="pi pi-map-marker"></i>}
                    {location.type === "airport" && <i className="pi pi-send"></i>}
                    {location.type === "pointOfInterest" && <i className="pi pi-sparkles"></i>}
                </div>
                <div className="mb-1">
                    {location.fullName}
                </div>
            </div>
        );
    };

    const emptySearchResult = {
        coordinates: {
            lat: 0,
            long: 0,
        },
        country: "",
        fullName: "",
        id: 0,
        name: "",
        score: 0,
        type: "",
    };

    // const updateSearchReults = (searchTerm: Location) => {
    //     if (locationsData.length !== 0) {
    //         locationsData.map((location) => {
    //             if (location.name === searchTerm.name) {
    //                 setSearchLocationId(location.id);
    //             }
    //         });
    //     }

    //     setSearchBarResult(searchTerm);
    // };

    const search = async (event: AutoCompleteCompleteEvent) => {
        let searchData = await getSuggestions(event.query);
        setLocationsData(searchData);
    };

    const getSuggestions = async (query: string) => {
        try {
            const resp = await axios.get(`${autoSuggestUrl}?term=${query}`);
            if (resp.status === 200) {
                return resp.data.locations;
            } else {
                console.warn("cant get search results");
            }
        } catch (ex) {
            console.error(ex);
        }
    };

    return (
        <>
            <div className="m-1">
                <div className="p-inputgroup flex-1">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-search"></i>
                    </span>
                    <AutoComplete
                        disabled={!isSearchEnabled}
                        required
                        placeholder="Search for city name, airport, landmark or a hotel"
                        field="fullName"
                        value={searchBarResult}
                        suggestions={locationsData}
                        completeMethod={search}
                        onChange={(e) => setSearchBarResult(e.value)}
                        itemTemplate={itemTemplate}
                    />
                </div>
            </div>
        </>
    );
}

export default SearchBar;
